import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  [<path fill="url(#a)" d="M.5 0h244v226H.5z" key="0" />,<defs key="1"><pattern id="a" width="1" height="1" patternContentUnits="objectBoundingBox"><use xlinkHref="#b" transform="matrix(.00066 0 0 .00071 -.1721 -.1903)" /></pattern></defs>,]
, 'GeneralMailboxx');
